import "./StatusChip.css";

export function getStatusChipTone(value) {
  const normalized = String(value ?? "")
    .trim()
    .toUpperCase();

  if (
    [
      "ACTIVE",
      "ENABLED",
      "TRUE",
      "COMPLETED",
      "SIGNED",
      "APPROVED",
      "SUCCESS",
      "APPLIED",
      "PROVISIONED",
    ].includes(normalized)
  ) {
    return "success";
  }

  if (
    ["PENDING", "SUSPENDED", "IN_PROGRESS", "PROCESSING"].includes(normalized)
  ) {
    return "warning";
  }

  if (
    [
      "REVOKED",
      "DISABLED",
      "FALSE",
      "FAILED",
      "ERROR",
      "DELETED",
      "REJECTED",
      "CANCELLED",
      "WITHDRAWN",
    ].includes(normalized)
  ) {
    return "danger";
  }

  if (["CREATED", "OPEN", "DRAFT", "RECEIVED"].includes(normalized)) {
    return "info";
  }

  return "neutral";
}

export default function StatusChip({
  label,
  value,
  tone,
  className = "",
  ariaLabel,
}) {
  const resolvedTone = tone || getStatusChipTone(value ?? label);
  const resolvedLabel =
    label ?? (value === null || value === undefined || value === "" ? "-" : String(value));

  return (
    <span
      className={`status-chip status-chip--${resolvedTone} ${className}`.trim()}
      role="status"
      aria-label={ariaLabel || resolvedLabel}
    >
      <span className="status-chip__dot" aria-hidden="true" />
      <span>{resolvedLabel}</span>
    </span>
  );
}
